import * as React from 'react';
import classNames from 'classnames';

// Styles
import '../styles/ConfirmedBookingTravelInfoItem.scss';

type Props = {
  icon: React.ReactNode;
  title?: string;
  value: string;
  subtitle?: string;
};

const ConfirmedBookingTravelInfoItem: React.FC<Props> = ({ icon, title, value, subtitle }) => {
  return (
    <div
      className={classNames('confirmed-booking-travel-info-item ', {
        'has--subtitle': subtitle,
        'is--centered': !title && !subtitle,
      })}>
      <div className="confirmed-booking-travel-info-item-icon">{icon}</div>
      <div className="confirmed-booking-travel-info-item-content">
        {title && <div className="confirmed-booking-travel-info-item-title">{title}</div>}
        <div className="confirmed-booking-travel-info-item-value">{value}</div>
        {subtitle && <div className="confirmed-booking-travel-info-item-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default ConfirmedBookingTravelInfoItem;
